import { Injectable } from '@angular/core';
import { InboxApplicationKey } from '@app/core/constants';
import { InboundFaxesQuery, InboxDto } from '@app/core/model';
import { InboundFaxesTableModelKeys } from '@app/shared/models';
import { FilterMetadata, LazyLoadEvent } from 'primeng/api';

@Injectable()
export class InboundFaxesTableQueryService {
  private readonly ODATA_QUERY_KEY = 'InboundFaxes:Table:Query';
  private readonly ODATA_DEFAULT_QUERY: InboundFaxesQuery = {
    isArchived: false,
    excludeNotes: false,
    skip: 0,
    take: 10,
    sortBy: InboundFaxesTableModelKeys.faxReceivedDateTime,
    sortOrder: 'ASC',
    faxFolderName: [],
    assignedUserName: [],
    memberSubscriberNumber: '',
    statusName: [],
    requestTypeName: [],
  };

  public initQuery(inbox: InboxDto, isArchived: boolean, forceReset = false): void {
    if (inbox) {
      const oDataQuery = this.ODATA_DEFAULT_QUERY;
      oDataQuery.excludeNotes = InboxApplicationKey.InboxesWithoutTenant.includes(inbox.applicationKey);

      if (isArchived !== null) {
        oDataQuery.isArchived = isArchived;
      }

      if (forceReset || !localStorage.getItem(this.ODATA_QUERY_KEY)) {
        localStorage.setItem(this.ODATA_QUERY_KEY, JSON.stringify(oDataQuery));
      }
    }
  }

  public getQuery(): InboundFaxesQuery | null {
    const cachedQueryString = localStorage.getItem(this.ODATA_QUERY_KEY);
    if (cachedQueryString) {
      return JSON.parse(cachedQueryString);
    }

    return null;
  }

  public updateQuery(inbox: InboxDto, updates: LazyLoadEvent | null): void {
    const oDataQuery: InboundFaxesQuery = JSON.parse(localStorage.getItem(this.ODATA_QUERY_KEY));
    if (updates) {
      oDataQuery.skip = updates.first ?? oDataQuery.skip;
      oDataQuery.take = updates.rows ?? oDataQuery.take;
      oDataQuery.sortBy = updates.sortField ?? oDataQuery.sortBy;
      oDataQuery.sortOrder = updates.sortOrder === 1 ? 'ASC' : updates.sortOrder === -1 ? 'DSC' : oDataQuery.sortOrder;
      oDataQuery.memberSubscriberNumber = (updates.filters['memberSubscriberNumber'] as FilterMetadata)?.value;
      oDataQuery.faxFolderName = (updates.filters['faxFolderName'] as FilterMetadata)?.value;
      oDataQuery.assignedUserName = (updates.filters['assignedUserName'] as FilterMetadata)?.value;
      oDataQuery.statusName = (updates.filters['statusName'] as FilterMetadata)?.value;
      oDataQuery.requestTypeName = (updates.filters['requestTypeName'] as FilterMetadata)?.value;
    }
    oDataQuery.excludeNotes = InboxApplicationKey.InboxesWithoutTenant.includes(inbox.applicationKey);
    localStorage.setItem(this.ODATA_QUERY_KEY, JSON.stringify(oDataQuery));
  }

  public resetArchive(): void {
    const oDataQuery: InboundFaxesQuery = JSON.parse(localStorage.getItem(this.ODATA_QUERY_KEY));
    oDataQuery.isArchived = false;
    localStorage.setItem(this.ODATA_QUERY_KEY, JSON.stringify(oDataQuery));
  }
}
